export default "__VITE_ASSET__BngoPvMS__"